import type { FC, RefAttributes } from 'react'
import React, { forwardRef } from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { Text, csx } from '@vtex/admin-ui'

export type TextWithEllipsisProps = TextProps & RefAttributes<HTMLSpanElement>

export const TextWithEllipsis: FC<TextWithEllipsisProps> = forwardRef(
  function TextWithEllipsis({ css, ...props }, ref) {
    return (
      <Text
        ref={ref}
        {...props}
        className={csx({
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        })}
        css={css}
      />
    )
  }
)
